import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";
import ReactTimeout from "react-timeout";

class GenerateMajorCardButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      submitting: false,
    };

    this.validated = this.validated.bind(this);
  }

  validated(values) {
    return this.props.editFunction(values);
  }

  render() {
    const actionButtonClassNames = classNames({
      invisible: !this.props.visible,
      "generate-button": true,
    });

    const actions = [];
    if (this.props.allowSubmission) {
      actions.push({
        id: 1,
        disabled: this.props.submitting || this.state.submitting,
        text: <FormattedMessage id="common.confirm" />,
        action: this.validate,
      });
    }
    return (
      <Button
        ref="action"
        className={actionButtonClassNames}
        bsStyle={"primary"}
        bsSize={"xsmall"}
        onClick={this.validated}
        disabled={this.props.disabled}
      >
        {this.props.label}
      </Button>
    );
  }
}

GenerateMajorCardButton.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  datatableActionButton: PropTypes.bool,
  disabled: PropTypes.bool,
  editFunction: PropTypes.func,
  getData: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  props: PropTypes.object,
  readOnly: PropTypes.bool,
  submitting: PropTypes.bool,
  setTimeout: PropTypes.func,
  download: PropTypes.bool,
  visible: PropTypes.bool,
  waitForData: PropTypes.bool,
  allowSubmission: PropTypes.bool,
};

GenerateMajorCardButton.defaultProps = {
  allowSubmission: true,
  datatableActionButton: true,
  submitting: false,
  visible: true,
  waitForData: false,
  download: false,
};

function mapStateToProps(state) {
  return {
    submitting: state.data.submitting,
  };
}

export default ReactTimeout(connect(mapStateToProps)(GenerateMajorCardButton));



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/GenerateMajorCardButton.js